import { render, staticRenderFns } from "./huotiList.vue?vue&type=template&id=709d1e46&scoped=true&"
import script from "./huotiList.vue?vue&type=script&lang=js&"
export * from "./huotiList.vue?vue&type=script&lang=js&"
import style0 from "./huotiList.vue?vue&type=style&index=0&id=709d1e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709d1e46",
  null
  
)

export default component.exports